AFRAME.registerComponent("artwork-medium", {
  schema: {
    image: { type: "string" },
    frame: { type: "string", default: null },
    artworkInfo: { type: "string" },
    glbModel: { type: "string" },
    scaleX: { type: "number", default: 1 },
    scaleY: { type: "number", default: 1 },
    mediumName: { type: "string" },
    completed: { type: "boolean", default: false },
    version: { type: "number", default: 1 },
    remoteArtwork: { type: "string" },
    canBeEdited: { type: "boolean", default: false },
    qrCodeId: { type: "string", default: "" },
    pinned: { type: "boolean", default: false }
  },
  init() {
    this.modelLoaded = false;
    this.el.addEventListener("model-loaded", this.onModelLoaded.bind(this));
  },
  update(oldData) {
    if (this.data.glbModel !== oldData.glbModel) {
      this.modelLoaded = false;
      this.el.removeAttribute("gltf-model-plus");

      if (this.data.glbModel) {
        this.el.setAttribute("gltf-model-plus", { src: this.data.glbModel });
        this.el.emit("load-start");
      }
    }
  },
  onModelLoaded() {
    this.updateMaterial();
  },
  createBoundingBoxFromObject(obj) {
    return new AFRAME.THREE.Box3().setFromObject(obj);
  },
  async updateMaterial() {
    const model = this.el.getObject3D("mesh");

    if (model) {
      const frontMesh = model.getObjectByName("front");

      if (frontMesh && this.data.image) {
        // Load texture
        const textureLoader = new AFRAME.THREE.TextureLoader();

        try {
          const texture = await new Promise((resolve, reject) => {
            textureLoader.load(
              this.data.image,
              tex => resolve(tex),
              undefined,
              err => reject(err)
            );
          });

          const textureWidth = texture.image.width;
          const textureHeight = texture.image.height;
          const aspectRatio = textureWidth / textureHeight;

          // Clone material and apply texture
          const material = frontMesh.material.clone();
          material.toneMapped = false;
          material.map = texture;
          material.map.colorSpace = THREE.SRGBColorSpace;
          material.map.flipY = false;

          // Apply material
          frontMesh.material = material;

          // DON'T scale the front mesh - we'll scale the entire entity instead
          // Get the current entity scale (which may have been set by the editor)
          const currentEntityScale = this.el.object3D.scale;
          const baseScale = Math.max(currentEntityScale.x, currentEntityScale.y);

          // Apply aspect ratio while preserving the base scale
          // For landscape: longest dimension keeps base scale, shorter is scaled proportionally
          // For portrait: same logic
          let scaleX, scaleY;
          if (aspectRatio > 1) {
            // Landscape: width is larger
            scaleX = baseScale;
            scaleY = baseScale / aspectRatio;
          } else {
            // Portrait or square: height is larger or equal
            scaleX = baseScale * aspectRatio;
            scaleY = baseScale;
          }

          this.el.object3D.scale.set(scaleX, scaleY, 1);
          if (this.el.object3D.updateMatrices) {
            this.el.object3D.updateMatrices();
          } else {
            this.el.object3D.updateMatrix();
            this.el.object3D.updateMatrixWorld(true);
          }

          // Make visible and emit events
          this.el.object3D.visible = true;
          this.el.emit("load-ended");
          this.el.parentEl.emit("medium-loaded");
        } catch (error) {
          // Error loading texture
        }
      }
    }
  }
});
